import React from 'react'
import { PauseCircle } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import { ReportRowState } from './reportFormatters'

/** Inline label rendered beside the report name (failure reason / paused state). */
const ReportStatusLabel: React.FC<{ state: ReportRowState }> = ({ state }) => {
  if (!state.inlineLabel) return null

  if (state.status === 'paused') {
    return (
      <span className='inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-text-xs-medium text-zinc-500'>
        <Icon IconComponent={PauseCircle} size='xs' className='text-zinc-400' iconProps={{ weight: 'fill' }} />
        {state.inlineLabel}
      </span>
    )
  }

  // Failure is surfaced by the warning pill in the count column (with tooltip), not an inline text label.
  return null
}

export default ReportStatusLabel
